import { HeaderLogo } from '@/components/HeaderLogo'
import ModalMegaMenu from '@/components/Popup/ModalMegaMenu'
import { SearchBar } from '@/components/SearchBar'
import { PageType } from '@/constants'
import { useRouterBack } from '@/hooks/useRouterBack'
import { IconBack, IconHome } from '@/styles/Icon'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useMemo, useState } from 'react'
interface HeaderType {
  layout: string
  page: string
  dataHeader: string | undefined
  btnHome?: boolean
}
const Header = ({ layout, dataHeader, page, btnHome }: HeaderType) => {
  const [scrollY, setScrollY] = useState(0)
  const [open, setOpen] = useState(false)
  const handleScroll = () => {
    setScrollY(document.documentElement.scrollTop)
  }
  const handleGoBack = useRouterBack()
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll)
      return () => window.removeEventListener('scroll', handleScroll)
    }
  })

  const headerDefault = useMemo(() => {
    return (
      <div className='flex h-[60px] items-center justify-between px-1 w-full'>
        <div className='flex-[40px] max-w-[40px]'>
          <button
            className='h-10 w-10 outline-none flex justify-center items-center'
            onClick={() => handleGoBack(true)}
          >
            <IconBack />
          </button>
        </div>

        <div className='flex-1 w-full px-1'>
          <h1 className='text-base break-all text-dark-800 overflow-hidden text-ellipsis font-bold line-clamp-1'>
            {dataHeader}
          </h1>
        </div>
        {btnHome ? (
          <div className='flex-[40px] max-w-[40px]'>
            <Link
              className='h-10 w-10 outline-none flex justify-center items-center'
              href={'/'}
            >
              <IconHome />
            </Link>
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }, [dataHeader])
  return (
    <header
      className={`${scrollY > 0 && layout == PageType.HOMEPAGE ? '' : ''} ${
        dataHeader != PageType.HOMEPAGE ? '' : 'shadow-100'
      } ${
        layout == '' ? '' : ''
      } flex h-[60px] w-full max-w-[440px] items-center justify-between bg-white `}
    >
      {layout === PageType.POST ? (
        headerDefault
      ) : (
        <div className={`flex w-full items-center justify-between gap-2 px-2`}>
          <div className='relative max-w-[80px] flex-[0_0_80px]'>
            {page && page == 'homepage' ? (
              <h1 className='block w-full'>
                <HeaderLogo />
              </h1>
            ) : (
              <div className='block w-full'>
                <HeaderLogo />
              </div>
            )}
          </div>
          <SearchBar />
          <div className='right'>
            <button
              className='flex items-center justify-center w-10'
              type='button'
              onClick={() => setOpen(true)}
            >
              <Image
                src='/assets/icons/menu-bar-mb.svg'
                width={24}
                height={24}
                alt='Danh mục'
                className=''
              />
            </button>
          </div>
        </div>
      )}

      <ModalMegaMenu open={open} setOpen={setOpen} />
    </header>
  )
}
export { Header }
